import {charcoal} from '../sass/base/_exports.sass';

export const HeartCircleIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 ${width} ${height}`}
      style={style}
      className={className}
    >
      <path
        d="M 16.371094 11.777344 L 16 12.148438 L 15.628906 11.777344 C 15.289062 11.433594 14.882812 11.160156 14.433594 10.972656 C 13.988281 10.785156 13.507812 10.6875 13.023438 10.6875 C 12.539062 10.6875 12.058594 10.785156 11.613281 10.972656 C 11.164062 11.160156 10.761719 11.433594 10.421875 11.777344 C 10.074219 12.117188 9.800781 12.523438 9.613281 12.96875 C 9.425781 13.417969 9.332031 13.898438 9.332031 14.382812 C 9.332031 14.867188 9.425781 15.347656 9.613281 15.792969 C 9.800781 16.242188 10.074219 16.644531 10.421875 16.988281 L 16 22.566406 L 21.582031 16.988281 C 21.925781 16.644531 22.199219 16.242188 22.386719 15.792969 C 22.574219 15.347656 22.671875 14.867188 22.671875 14.382812 C 22.671875 13.898438 22.574219 13.417969 22.386719 12.96875 C 22.199219 12.523438 21.925781 12.117188 21.582031 11.777344 C 21.242188 11.433594 20.835938 11.160156 20.386719 10.972656 C 19.941406 10.785156 19.460938 10.6875 18.976562 10.6875 C 18.492188 10.6875 18.011719 10.785156 17.566406 10.972656 C 17.117188 11.160156 16.710938 11.433594 16.371094 11.777344 Z M 16.371094 11.777344 "
        fill={color}
      />
      <path
        d="M 16 2.667969 C 8.648438 2.667969 2.667969 8.648438 2.667969 16 C 2.667969 23.351562 8.648438 29.332031 16 29.332031 C 23.351562 29.332031 29.332031 23.351562 29.332031 16 C 29.332031 8.648438 23.351562 2.667969 16 2.667969 Z M 16 26.667969 C 10.117188 26.667969 5.332031 21.882812 5.332031 16 C 5.332031 10.117188 10.117188 5.332031 16 5.332031 C 21.882812 5.332031 26.667969 10.117188 26.667969 16 C 26.667969 21.882812 21.882812 26.667969 16 26.667969 Z M 16 26.667969 "
        fill={color}
      />
    </svg>
  );
};
